export default __webpack_public_path__ + "26bbbbd4b3f1e4eb1dc41eb1ec15fe32.png";